import { Text } from "@otrium/atoms";
import Link from "next/link";
import { ChevronRight } from "src/icons";
import { theme } from "src/theme";
import { BreadcrumbContainer, BreadcrumbItem } from "./Breadcrumb.styled";

export type BreadcrumbItem = {
  title: string;
  slug?: string;
};

type BreadcrumbProps = {
  data: BreadcrumbItem[];
  gender?: string;
};

function Breadcrumb({ data, gender }: BreadcrumbProps): JSX.Element | null {
  return data.length > 0 ? (
    <BreadcrumbContainer>
      {data.map((item, idx) => {
        return (
          <BreadcrumbItem
            key={`${item.title.toLowerCase().replaceAll(" ", "_")}_${idx}`}
          >
            {item.slug !== undefined ? (
              <Link
                href={`${gender ? `/${gender}` : ""}${
                  item.slug ? `${item.slug}` : ""
                }`}
              >
                {item.title}
              </Link>
            ) : (
              <Text>{item.title}</Text>
            )}
            {idx < data.length - 1 ? (
              <ChevronRight
                width={theme.fontSizes.fontSize20}
                height={theme.fontSizes.fontSize20}
                fill="#ccc"
              />
            ) : null}
          </BreadcrumbItem>
        );
      })}
    </BreadcrumbContainer>
  ) : null;
}

export { Breadcrumb };
